import { render, staticRenderFns } from "./onlineEMBA.vue?vue&type=template&id=a13407e6"
import script from "./onlineEMBA.vue?vue&type=script&lang=js"
export * from "./onlineEMBA.vue?vue&type=script&lang=js"
import style0 from "./onlineEMBA.vue?vue&type=style&index=0&id=a13407e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports